import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const ArtLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="8.66"
        y="8.77"
        width="67.44"
        height="67.08"
        rx="15.12"
        transform="translate(-15.35 26.38) rotate(-29.53)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(3 32) rotate(-29.53)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="77"
        y="20.39"
        width="67.24"
        height="66.88"
        rx="15.12"
        transform="rotate(-16.01)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(86 2) rotate(-16.01)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="174"
        y="-40"
        width="69.56"
        height="69.19"
        rx="15.12"
        transform="rotate(5.66)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(183 -15.5) rotate(5.66)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="29"
        y="94"
        width="66.42"
        height="66.07"
        rx="15.12"
        transform="rotate(-16.01)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(60 86) rotate(-16.01)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="150"
        y="39"
        width="67.24"
        height="66.88"
        rx="15.12"
        transform="rotate(5.66)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(150.5 59.5) rotate(5.66)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="227"
        y="71"
        width="67.24"
        height="66.88"
        rx="15.12"
        transform="rotate(5.66)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(224 99) rotate(5.66)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g className="digital-resources-art" transform="translate(750, -5)">
      <defs>
        <linearGradient
          id="a30c54b9-6d96-418a-8039-67b2149ec6c8"
          x1="87.93"
          y1="203.19"
          x2="84.07"
          y2="346.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#663d3c" />
          <stop offset="0.01" stopColor="#663d3c" />
          <stop offset="0.32" stopColor="#794545" />
          <stop offset="0.64" stopColor="#834a4a" />
          <stop offset="1" stopColor="#874c4c" />
        </linearGradient>
        <linearGradient
          id="a62b7155-d0b7-46fe-a53c-9be6daf56188"
          x1="178.8"
          y1="242.86"
          x2="150.52"
          y2="566.66"
          href="#a30c54b9-6d96-418a-8039-67b2149ec6c8"
        />
        <linearGradient
          id="bf6fd644-8fb7-4e4a-8c4f-85510b333c48"
          x1="246.21"
          y1="257.31"
          x2="228.32"
          y2="462.25"
          href="#a30c54b9-6d96-418a-8039-67b2149ec6c8"
        />
      </defs>
      <g className="art-island">
        <path
          d="M7.05,194.8s26.92,48.57,42,70.68c5.05,7.4,10.09-6.18,10.64-3.87.47,2,6.37,16.17,11.77,20.44,11.17,8.82,30.8,24.85,44.24,24.3a75,75,0,0,1,17.6,14.28l17.61,49.56,37.36-17.53,104.82-31.38,31-19.9,15.68-28.71s39.2-74.25,38.65-76.77-23.93-41.62-23.93-41.62l-73.62,88.37s13.89,39.19,10.61,40-98.64-19.3-107.41-26-4.38-12.59-4.38-12.59-18.64-8.39-34-9.23-27.95-25.17-37.81-33.56S81.56,197.93,69,204.64s-25.21,1.68-24.11-5.87S7.05,194.8,7.05,194.8Z"
          fill="#874c4c"
        />
        <path
          d="M68.09,223.5c9-5,15.13-7.17,21.85,1.66s7.84,69,14,76.77c3.92,4.42-12.32,1.1-24.08-15.47S68.09,223.5,68.09,223.5Z"
          fill="url(#a30c54b9-6d96-418a-8039-67b2149ec6c8)"
        />
        <path
          d="M150.91,370.19l27.52-79.86s1.67,57.36,7.55,62.33C174.55,359.52,150.91,370.19,150.91,370.19Z"
          fill="url(#a62b7155-d0b7-46fe-a53c-9be6daf56188)"
        />
        <path
          d="M214.2,336.64c4.2-15.74,9-48.52,9-48.52l16.8-1.29s5,22.68,22.19,36.85S214.2,336.64,214.2,336.64Z"
          fill="url(#bf6fd644-8fb7-4e4a-8c4f-85510b333c48)"
        />
        <path
          d="M91.41,241.49c-.31-3.64.1-7.37-.94-10.9-3.41-11.53-16.22-7.44-28-2.33-5.92,2.56-15.73-.79-22,1s-14.51.16-16.77-5.46c-.77-1.92-.73-4-1.36-6-1.31-4.05-5.22-6.85-8.28-10-5.93-6.16-8.89-14.2-11.7-22C1.08,182.23-.19,178.65,0,175c.57-9.36,10.21-15.78,18.9-20.79,15.72-9.05,2.11-18.65,17.83-27.71,18.51-10.65,72.46-7.4,94.23-9.3,23.92-2.09,42.17-6.59,66.19-6.13,21.74.42,44-6.25,64.88-.83,8.21,2.13,52.17,6.82,59.59,10.68,17,8.82,33.44,13.52,50.4,22.34,10.77,5.6-14,14.65-1.62,15.51,4,.28,8.26.07,11.85,1.75,6.53,3.05,8.18,11.05,6.9,17.65S384.5,191,384,197.64c-.21,2.64,0,5.46-1.46,7.75-3.83,6.07-16.46,4.73-18.17,11.56-.66,2.63.8,5.61-.58,8-2.21,3.8-10.61,6.12-7.42,9.29a9.06,9.06,0,0,0,3,1.38c5.61,2.38,3.49,11-2.11,13.37s-12.14.73-18.13-.67-12.92-2.35-17.85,1.05c-2.72,1.88-4.64,5-8,5.69-2,.42-4.08-.15-6.14-.09-7.48.19-11.54,7.88-13.93,14.37l33.64,7.52c4.33,1,6.25,6-3.45,8.9s-20.06,3-30.25,3c-45.1.28-92,3.93-136.89.08C130.47,286.64,93.63,267.57,91.41,241.49Z"
          fill="#68c902"
        />
        <path
          d="M94.7,231.19c-9.88-4.43-14-1.43-11.34,1.15S107,236.71,94.7,231.19Z"
          fill="#68c902"
        />
        <path
          d="M33.84,232.8l.5-1.16c.51,1.62,3.35,1.68,3.93.08.74,1.27,2.21,2.75,3.44,1.92.33-.22.55-.59.87-.83,1.06-.79,2.58.07,3.46,1.05s1.79,2.22,3.12,2.27a6.31,6.31,0,0,0,.65-4.52,15.21,15.21,0,0,0,3.8,2.71,12.32,12.32,0,0,0,.88-3.37c.8,1.83,3.52,1.41,5.4.68l7.87-3.06a36,36,0,0,1,3.65,8.13c-.75-3.68-1.18-8.23,1.88-10.47a38.67,38.67,0,0,0,.63,7.89c4.77-4.53,4.6-12,4.1-18.48a82.48,82.48,0,0,0-8.35,2.64,101.36,101.36,0,0,1-15.86,3.34l-18.57,2.89c-2,.3-5.74.15-6.13,2.7C28.87,228.72,32.29,232.8,33.84,232.8Z"
          fill="#68c902"
        />
        <ellipse cx="236.12" cy="272.2" rx="26.88" ry="6.9" fill="#54ba02" />
        <path
          d="M236.12,265.29c-13,0-23.78,2.36-26.32,5.5,4.59-2.13,13.4-3.56,23.52-3.56,14.85,0,26.88,3.09,26.88,6.9a2.24,2.24,0,0,1-.56,1.41c2.14-1,3.36-2.13,3.36-3.34C263,268.38,251,265.29,236.12,265.29Z"
          fill="#4fb002"
        />
        <ellipse cx="192.81" cy="279.38" rx="15.41" ry="3.96" fill="#54ba02" />
        <path
          d="M192.81,275.42c-7.44,0-13.64,1.35-15.09,3.15,2.63-1.22,7.68-2,13.48-2,8.51,0,15.41,1.77,15.41,4a1.28,1.28,0,0,1-.32.81c1.23-.56,1.93-1.22,1.93-1.91C208.22,277.19,201.32,275.42,192.81,275.42Z"
          fill="#4fb002"
        />
        <ellipse cx="323.12" cy="230.04" rx="18.67" ry="4.79" fill="#54ba02" />
        <path
          d="M323.12,225.25c-9,0-16.52,1.63-18.28,3.81,3.19-1.47,9.31-2.47,16.33-2.47,10.32,0,18.67,2.14,18.67,4.79a1.51,1.51,0,0,1-.39,1c1.49-.69,2.34-1.48,2.34-2.32C341.79,227.39,333.43,225.25,323.12,225.25Z"
          fill="#4fb002"
        />
        <ellipse cx="294.88" cy="224.66" rx="9.86" ry="2.53" fill="#54ba02" />
        <path
          d="M294.88,222.12c-4.75,0-8.72.87-9.65,2a23.16,23.16,0,0,1,8.63-1.31c5.44,0,9.85,1.14,9.85,2.53a.85.85,0,0,1-.2.52c.78-.36,1.23-.78,1.23-1.22C304.74,223.26,300.33,222.12,294.88,222.12Z"
          fill="#4fb002"
        />
        <path
          d="M57.78,247.39s-7.84-.37-9.15.92-8.59.37-8.59.37l-1.12-4.42a52.1,52.1,0,0,0-3.17,4.23c-.19.56-.93,2.95-.93,2.95L36.5,257l1.12-4.23,2.8.74a22.45,22.45,0,0,1,.74,2.94c0,.55,1.5-3.13,1.5-3.13l2.42.92L46,252l1.86,1.29.57,3.87,1.68-5.89,1.3,1.28,1.12-2,1.68-.92Z"
          fill="#45a102"
        />
        <path
          d="M181.44,305.65l3.49,2.52,7,.19,16.21-1.74s-6.18,3.09-6.74,3.24-10.77.83-10.77.83l-2.66,2.9-1.47-2.76-1.37-.25-.74,3.77-1.69-4.49-2.61,1.59-.38-2.9Z"
          fill="#45a102"
        />
        <path
          d="M191.45,288.59c5.07,1.21,11.46-.62,16.67-.33,3.78.21,6.58-.27,10.36-.55,26.5-2,52.7-.71,79.2-2.69,5.58-.42,11.24-.83,16.75.18,1.32.24,3,1.09,2.61,2.36-.26.94-1.45,1.23-2.43,1.35l-16.9,2a6.58,6.58,0,0,1-3.24,5.87,19.72,19.72,0,0,0,.15-5.84,33.51,33.51,0,0,1-9.6.67l-2.26-.06-13.66-.35,1.15,2.25a27.7,27.7,0,0,0-18.62-.59,37.52,37.52,0,0,1,8.75,3.33,31,31,0,0,1-18-3.76,5.73,5.73,0,0,1-6.3,1.11,5.18,5.18,0,0,1-7.81-.93l-.76,9.91a23.36,23.36,0,0,1-4.13-11,6.06,6.06,0,0,1-6.54,1.75,25.37,25.37,0,0,1-16.71-1c-3.46-1.41-6.25-3.88-10-4.65-5.56-1.14-11.65.47-17.36-.07A123.16,123.16,0,0,1,156,284.45c-7.79-1.85-18.7-5.93-26.67-4a8.09,8.09,0,0,0,4.93,6.13c.94.41,2.49.26,2.44-.75.55,1.38,1.2,2.88,2.54,3.57s3.45-.16,3.29-1.64c3.34,2.89,8.5,4.3,12.26,2a5.59,5.59,0,0,0,7.72,1.57l3.49,7a24.56,24.56,0,0,0,3.53-7.78,3.3,3.3,0,0,0,4.92,1.16c1.49,2.4,4.61,3.42,7.45,3.22s5.5-1.42,8.09-2.6l1,4.34c1.42-1.22,2.72-2.87,2.61-4.72a3.76,3.76,0,0,0-.52-1.67"
          fill="#68c902"
        />
        <path
          d="M308,263.57a12.8,12.8,0,0,0-4-4.22l8.71-1.12-3.62-1.33A44.72,44.72,0,0,0,330.39,255a40.6,40.6,0,0,0-9.89-2.52,15.18,15.18,0,0,1,11.15-2.47c2.66.47,6.06,1.37,7.54-.86l5.1,1.63c.53-.83-.32-1.84-1.12-2.41-6.58-4.72-15.27-6-23.28-4.68s-15.44,5.18-22,9.89a11.1,11.1,0,0,0-2.95,2.76c-1.59,2.44-4.46,11.68.6,12,3,.18,2.49-3,4-4.07C300.08,263.9,307.45,262.67,308,263.57Z"
          fill="#68c902"
        />
        <path
          d="M48.54,122.6a6,6,0,0,0,2.51-2.84,5.67,5.67,0,0,0,6.66,1.33A5.52,5.52,0,0,0,60.52,115l2.69,8.64c4.94-6,11.69-12.68,19.31-10.83a6.55,6.55,0,0,0-7.25,5.78,11.61,11.61,0,0,1,8.59.48,3.66,3.66,0,0,0,2.3-2.1c.88,2,4.31,1.24,5.16-.78s0-4.3-.84-6.32a22.47,22.47,0,0,1,8.42,10l5.14-3.19c-1.17,1.09,1.68,1.94,3,1.06s4.17-.79,3.47.64A67.2,67.2,0,0,1,115,103.73a27.36,27.36,0,0,0,2.23,13.36,5,5,0,0,0,2.18-2.36c-.09,1,1.22,1.52,2.26,1.64a40.29,40.29,0,0,0,28.4-7.55l-3.59,6.41a30.15,30.15,0,0,1,17.92-2.2l.16-5,9.28,4.36,2.36-3a20,20,0,0,0,4.47,4.75c-2,3.31-6.52,3.91-10.42,4.14q-21.76,1.29-43.57,1.8c-17.31.41-34.77.52-51.83,3.72-8.24,1.55-16.51,6.23-24.54,7.37-7.41,1.05-10.35-6.12-7.2-12.61A12.79,12.79,0,0,1,48.54,122.6Z"
          fill="#68c902"
        />
        <path
          d="M187.64,109.63a22.62,22.62,0,0,1,2.25.72c4.35,1.16,7.85-3.46,9.93-7.41l1.7,2.32a2.9,2.9,0,0,0,2.35-.89l6.51,4.54a7.59,7.59,0,0,0,7.28-3.59c.05,2.62,3.61,3.78,6.15,3s4.6-2.68,7.14-3.46,6.1.41,6.13,3l2.93-1.34c-.87.52.42,1.69,1.44,1.67a8.08,8.08,0,0,0,7.22-4.9L253,108l3.18-2.09a6.33,6.33,0,0,0,2.81,3.33,16.4,16.4,0,0,1,7.39-9,26.65,26.65,0,0,0-2.81,9.86l3.24-2.56c2,1.74,1,5.31-1.26,6.76s-5.14,1.39-7.83,1.31q-23.52-.75-47.06,0c-6.84.2-15.3,2.06-22,1.06-2.22-.34-3.89.6-5-2C182.71,112.25,184.93,109.16,187.64,109.63Z"
          fill="#68c902"
        />
        <path
          d="M369.29,137.88l-3.14.89-1.22-1.88c.19,1-1.32,1.66-2.22,1.12a3.61,3.61,0,0,1-1.4-2.66,21.63,21.63,0,0,1,0-7.57,16,16,0,0,0-3.82,6.57l-1-1.9-1.67.77c-1.91.1-3.52-2.54-5.24-1.7-.41.2-.73.58-1.17.7-.66.18-1.3-.3-1.85-.71a17.85,17.85,0,0,0-9.66-3.59c3.19,5.33,9.07,8.47,14.79,11,4.08,1.85,23.65,12.2,23.08.69-.88.89-2.79,1.23-3.74,2C371,141.46,369,138,369.29,137.88Z"
          fill="#68c902"
        />
      </g>
      <g className="art-island-decor">
        <path
          d="M263.75,185.11a10.12,10.12,0,0,1-.13-3.72l1.37,2a4,4,0,0,1,1.56-1.69,9,9,0,0,0,2.33,2.55l1.9-1.53a1.81,1.81,0,0,0,2.31,1.31,5.24,5.24,0,0,0,2.38-1.8l.89,2a6.12,6.12,0,0,0,2.23-1.37,1.94,1.94,0,0,0,.67,1.68A36.1,36.1,0,0,1,290.81,167a51.28,51.28,0,0,0-11.23,23.41,22.86,22.86,0,0,1,7-7.16,1.37,1.37,0,0,0,.07,2,101.24,101.24,0,0,1-7,12,34.46,34.46,0,0,0-3.53-10l-1.62,2.37a3.75,3.75,0,0,1-1.83-1.61,3.45,3.45,0,0,0-1.87-1.55c-.81-.17-1.8.59-1.51,1.37-1.35-1.21-2.67-2.52-4.12-3.59-.19,2.14.42,4.76-.31,6.74-3.28-2.71-3.89-9.87-5.83-13.57C260.6,180,262.17,182.56,263.75,185.11Z"
          fill="#55a32a"
          transform="translate(20, -20)"
        />
        <g transform="translate(-225, -37)">
          <ellipse
            cx="277.36"
            cy="249.33"
            rx="18.41"
            ry="4.51"
            fill="#54ba02"
          />
          <path
            d="M288.8,236.3c0,8.73-2.76,17.79-16.26,18.11-12.74.31-17.19-9.38-17.19-18.11s8-13.5,17.19-13.5S288.8,227.58,288.8,236.3Z"
            fill="#e7fcfd"
          />
          <path
            d="M271.38,244c9,0,14.33-4,14.62,4.12,2.16-3.34,2.8-7.6,2.8-11.8,0-8.72-7-13.5-16.26-13.5s-17.19,4.78-17.19,13.5a16.91,16.91,0,0,0,.6,5.14A51.25,51.25,0,0,0,271.38,244Z"
            fill="#acdef3"
          />
          <path
            d="M296.52,229.24c0,6.32-11.12,11.44-24.84,11.44s-24.85-5.12-24.85-11.44,12.45-15.16,26.17-15.16S296.52,222.93,296.52,229.24Z"
            fill="#ffa511"
          />
          <path
            d="M289.34,219c3,2.17,4.73,6.22,4.73,8.53,0,5.74-14,9.61-27.18,9.61-5.43,0-12-.5-16-1.84,3.94,3.36,13.5,5.37,22.75,5.37,13.14,0,23.8-4.66,23.8-10.4C297.44,226.54,294.17,222.14,289.34,219Z"
            fill="#ff6911"
          />
          <ellipse cx="261.72" cy="225.91" rx="6.72" ry="2.76" fill="#feb93e" />
          <ellipse cx="281.73" cy="224.17" rx="4.95" ry="2.04" fill="#feb93e" />
          <ellipse cx="268.19" cy="218.1" rx="2.7" ry="1.11" fill="#feb93e" />
          <path
            d="M285.35,251.13a3.06,3.06,0,0,0-1.88,1.87,9.66,9.66,0,0,0-.09-2.63l-1,1.59-.28-1a9.26,9.26,0,0,0-1.45,1.55,10.58,10.58,0,0,0-2.72-4.6c-.82,1.1-.23,2.65-.43,4a.68.68,0,0,1-.21.44.69.69,0,0,1-.47.06,5.51,5.51,0,0,1-3-1.42l-.37,1.35a.81.81,0,0,0-.36-.57l-.24.93a2.75,2.75,0,0,0-3.73-.33,9.86,9.86,0,0,0,4.37,1.92,41.91,41.91,0,0,0,11.15,1.32c3.22-.1,2.89-2.3,3.29-5A6.71,6.71,0,0,0,285.35,251.13Z"
            fill="#68c902"
          />
        </g>
        <g transform="translate(-20, 0)">
          <path
            d="M187.1,257.88c-.63-.09-.94-.39-.94-.89s0-.78,0-1.12a6.06,6.06,0,0,1,.08-.92.79.79,0,0,1,.31-.55,1,1,0,0,1,.54-.15c.2,0,.55,0,1.05.07.5-1.53,1-3,1.61-4.53s1.12-2.91,1.67-4.23a1.48,1.48,0,0,1,1.06-.92c.4-.08.82-.14,1.26-.19s.84-.07,1.19-.07l.59,0c.17,0,.33,0,.47,0a1.39,1.39,0,0,1,1.12.8c.49,1,1.07,2.21,1.75,3.77s1.36,3.29,2,5.18l.58,0,.32,0h.2a.8.8,0,0,1,.84.68,5.1,5.1,0,0,1,.17,1.38v.39a2,2,0,0,1,0,.41.89.89,0,0,1-.89.89c.11.36.21.7.29,1s.16.6.22.85.08.32.09.39,0,.13,0,.18a.72.72,0,0,1-.56.75,13.71,13.71,0,0,1-1.44.34,9.54,9.54,0,0,1-1.52.12.85.85,0,0,1-.63-.2,1.29,1.29,0,0,1-.33-.62l-.65-2.43c-.89,0-1.79.07-2.7.07-.58,0-1.15,0-1.72,0s-1.13,0-1.68-.07c-.11.46-.21.9-.3,1.33s-.18.84-.26,1.25a.85.85,0,0,1-.91.8,8.92,8.92,0,0,1-1.44-.14,14.44,14.44,0,0,1-1.42-.33.76.76,0,0,1-.59-.77,1.28,1.28,0,0,1,0-.17,2.4,2.4,0,0,1,0-.33c.05-.25.12-.55.2-.9S187,258.26,187.1,257.88Zm5.41-3.51h1.92l1.94,0c-.29-1-.61-1.9-1-2.83s-.71-1.83-1.1-2.67q-.51,1.46-1,2.82C193.06,252.57,192.77,253.48,192.51,254.37Z"
            fill="#fff"
          />
          <path
            d="M204.2,251a5.26,5.26,0,0,1,.11-.91.65.65,0,0,1,.55-.48c.19,0,.4-.08.65-.11l.78-.09.79-.05.68,0a.54.54,0,0,1,.47.17.72.72,0,0,1,.12.44c0,.09,0,.21,0,.34a3.6,3.6,0,0,1,0,.36,5.38,5.38,0,0,1,1.47-.93,4.23,4.23,0,0,1,1.74-.35,1.15,1.15,0,0,1,1,.51A3.06,3.06,0,0,1,213,251a7.1,7.1,0,0,1,.13,1.19q0,.65,0,1.11a1.49,1.49,0,0,1-.25.85,2.46,2.46,0,0,1-.9.77c-.2.1-.46.22-.77.34a2.47,2.47,0,0,1-.75.17.66.66,0,0,1-.61-.34,1.38,1.38,0,0,1-.21-.74c0-.17,0-.39,0-.68a3.53,3.53,0,0,0-.09-.72q-.33.17-.6.33a5.17,5.17,0,0,0-.67.49c0,.84,0,1.63.07,2.38s.07,1.4.11,2,.08,1,.12,1.43.06.64.06.77a.8.8,0,0,1-.25.61,1.79,1.79,0,0,1-1,.25,1.94,1.94,0,0,1-.36,0h-.81a2,2,0,0,1-.35,0,1.3,1.3,0,0,1-1-.33,1.65,1.65,0,0,1-.29-.84c-.13-1.19-.23-2.39-.3-3.62s-.12-2.45-.12-3.67v-.84C204.18,251.58,204.18,251.3,204.2,251Z"
            fill="#fff"
          />
          <path
            d="M213.65,251.72a2.65,2.65,0,0,1,0-.63.74.74,0,0,1,.23-.38,1,1,0,0,1,.44-.2,7.31,7.31,0,0,1,.75-.1v-.66c0-.3,0-.59,0-.89s0-.62,0-1a2.53,2.53,0,0,1,.13-.75.89.89,0,0,1,.43-.49,2.69,2.69,0,0,1,1-.28,10.79,10.79,0,0,1,1.7-.1.9.9,0,0,1,.75.27,1.26,1.26,0,0,1,.21.79c0,.08,0,.22,0,.43s0,.47,0,.76,0,.61-.05.93,0,.62-.05.9l.81.08c.28,0,.55.06.84.11a1,1,0,0,1,.65.29,1,1,0,0,1,.19.69,5.4,5.4,0,0,1,0,.62c0,.26-.05.5-.08.72a1,1,0,0,1-.33.64,1.42,1.42,0,0,1-.75.22,5,5,0,0,1-.69.07l-.55,0c0,.51,0,1.11.07,1.78s.07,1.32.11,1.94.07,1.19.09,1.69,0,.83,0,1a1,1,0,0,1-.18.63,1.08,1.08,0,0,1-.67.28,11.76,11.76,0,0,1-1.78.14,1,1,0,0,1-.67-.2,1.23,1.23,0,0,1-.29-.76c-.15-1.11-.28-2.2-.39-3.28s-.19-2.2-.27-3.35l-.6-.07a1.46,1.46,0,0,1-.72-.22,1,1,0,0,1-.27-.72c0-.17,0-.34,0-.52S213.65,251.84,213.65,251.72Z"
            fill="#fff"
          />
        </g>
      </g>
      <g className="art-flag">
        <ellipse cx="339.98" cy="193" rx="20.35" ry="11.73" fill="#55a32a" />
        <polygon
          points="275.82 155.82 276.56 156.35 277.22 155.37 275.82 155.82"
          fill="#6fa4ff"
        />
        <path
          d="M344.12,197.64c0,3.75-6.87,6.79-15.34,6.79s-15.33-3-15.33-6.79c0-.78.06-3,.06-3s8.56-3.74,15.27-3.74,15.3,3.68,15.3,3.68S344.12,196.83,344.12,197.64Z"
          fill="#8abcf8"
        />
        <ellipse cx="328.78" cy="194.8" rx="15.34" ry="6.79" fill="#9ae1f8" />
        <path
          d="M328.29,193.11c1.26,1.15,12.57-2.72,12.57-2.72s-4.23-1.58-5-1.77a45.22,45.22,0,0,0-8.84,2.72Z"
          fill="#8aa6f8"
        />
        <path
          d="M329,193.82H326.5V23.49L328.77,0l2.3,23.49V191.74A2.08,2.08,0,0,1,329,193.82Z"
          fill="#9ae1f8"
        />
        <path
          d="M328.77,0l-1,10.82L329,23.68V193.82h0a2.09,2.09,0,0,0,2.09-2.09V23.49Z"
          fill="#8abcf8"
        />
        <path
          d="M360.86,61.4s7.8,44.29-5.21,75.24c-7.2,17.12-29.88,32.47-29.88,32.47l-15.41-22.93-33.8,10.17A218.52,218.52,0,0,0,294.74,120c6.47-16.59,4.56-63.41,4.56-63.41Z"
          fill="#6fa4ff"
        />
        <rect
          x="295.55"
          y="54.67"
          width="72.26"
          height="3.92"
          rx="1.73"
          transform="translate(655.86 146.78) rotate(-174.15)"
          fill="#9ae1f8"
        />
        <path
          d="M360.45,61.34s7.37,43.71-5.64,74.66c-7.2,17.13-29.58,32.39-29.58,32.39l-15.52-23-33.89,10.47a232.73,232.73,0,0,0,18.54-37.14c6.47-16.6,4.56-63.41,4.56-63.41Z"
          fill="#98eeff"
        />
        <path
          d="M356.94,57.23a2.66,2.66,0,0,0,0,4c-7.52-.74-18.47-1.85-18.47-1.85s-2.12-2.25.35-4C344.83,55.82,356.94,57.23,356.94,57.23Z"
          fill="#98eeff"
        />
        <path
          d="M321,53.46a2.65,2.65,0,0,0,0,4c-7.52-.74-18.47-1.85-18.47-1.85s-2.13-2.25.35-4C308.87,52,321,53.46,321,53.46Z"
          fill="#98eeff"
        />
        <path
          d="M326.5,23.49V35.05a4.6,4.6,0,0,0,2.84.62c.45,0,1.29-.25,1.73-.29V23.49L328.77,0Z"
          fill="#cfdff1"
        />
        <path
          d="M295.71,53.17l.05-.46a1.73,1.73,0,0,1,1.9-1.54h.14a1.69,1.69,0,0,0-.05.24l0,.45a1.73,1.73,0,0,0,1.54,1.9l68.3,7a1.71,1.71,0,0,1-1.84,1.31l-68.45-7A1.73,1.73,0,0,1,295.71,53.17Z"
          fill="#9ae1f8"
          opacity="0.5"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path
          d="M328.77,0l-.49,5.05,1.65,16.86.22,12.3a15.61,15.61,0,0,1-1.92.06A8.36,8.36,0,0,1,326.5,34v1.09a4.6,4.6,0,0,0,2.84.62c.45,0,1.29-.25,1.73-.29V23.49Z"
          fill="#bad2f1"
        />
        <path
          d="M331.29,34.69c0,.57-1.12,1-2.49,1s-2.49-.47-2.49-1"
          fill="none"
          stroke="#cfdff1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M298.92,55.28s.77,18.91-.33,37c16.74,5.73,45.6,11.93,63.31,12.47a192.57,192.57,0,0,0-1.45-43.36Z"
          fill="#74a9ff"
          opacity="0.13"
        />
        <g>
          <g>
            <polygon
              points="312.33 127.34 310.56 127.61 307.83 121.53 308.43 118.66 340.34 82.78 344.25 91.46 312.33 127.34"
              fill="#fe9c1b"
            />
            <polygon
              points="343.69 90.22 340.34 82.78 308.43 118.66 307.83 121.53 310.52 127.51 343.69 90.22"
              fill="#fede25"
            />
            <polygon
              points="341.08 84.43 340.34 82.78 308.43 118.66 307.83 121.53 307.92 121.73 341.08 84.43"
              fill="#fef787"
            />
            <polygon
              points="340.34 82.78 339.83 85.83 342.45 91.61 344.25 91.46 348.4 80.19 340.34 82.78"
              fill="#fdf8ea"
            />
            <path
              d="M345.37,81.17a4.61,4.61,0,0,0,.35,2.07,2.38,2.38,0,0,0,1.11,1.2l1.57-4.25Z"
              fill="#141412"
            />
          </g>
          <ellipse
            cx="327.29"
            cy="106.73"
            rx="4.68"
            ry="29.79"
            transform="translate(-6.21 192.09) rotate(-32.42)"
            fill="#7122ad"
          />
          <path
            d="M342.89,126.59c-2.2,1-10.27-8-18.72-20.94C318,96.2,313.28,87.08,311.42,81.54a.74.74,0,0,0-.33.28c-1.57,2.34,4.41,15.4,13.36,29.15s17.48,23,19,20.67C344,130.9,343.74,129.12,342.89,126.59Z"
            fill="#5f1dad"
          />
          <path
            d="M311.09,81.82c-1.19,1.78,2,9.75,7.5,19.51a34.54,34.54,0,0,0,5.17-8C317.44,84.91,312.27,80,311.09,81.82Z"
            fill="#d9d8d9"
          />
          <ellipse
            cx="318.27"
            cy="90.03"
            rx="1.27"
            ry="6.71"
            transform="translate(5.88 198.73) rotate(-34.98)"
            fill="#fdf8ea"
          />
          <path
            d="M316.71,79c-.11-4.72-2.75-7.94-5.91-7.18a5.22,5.22,0,0,0-2.27,1.27c-1-.17-2-1.46-2.62-5.54,0,0-2.94,14.17,1,19.81l.08-.07A4,4,0,0,0,311.18,89C314.34,88.2,316.81,83.76,316.71,79Z"
            fill="#733b21"
          />
          <path
            d="M316.68,78.59c-.92,2.84-2.74,5-4.88,5.57a4,4,0,0,1-4.17-1.63l-.09.07c-2.24-3.2-2.27-9.16-1.86-13.71-.62,3.63-2,13.91,1.25,18.51l.08-.07A4,4,0,0,0,311.18,89c3.16-.76,5.63-5.2,5.53-9.92Z"
            fill="#5c3621"
          />
        </g>
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(27, 86)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default ArtLink;
